var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPencilOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.632545 12C0.670041 12 0.707537 11.9963 0.745034 11.9906L3.89847 11.4375C3.93597 11.43 3.97159 11.4131 3.99784 11.385L11.9452 3.43687C11.9626 3.41953 11.9763 3.39892 11.9858 3.37624C11.9952 3.35356 12 3.32924 12 3.30469C12 3.28013 11.9952 3.25582 11.9858 3.23313C11.9763 3.21045 11.9626 3.18985 11.9452 3.1725L8.82923 0.054375C8.79361 0.01875 8.74674 0 8.69612 0C8.6455 0 8.59863 0.01875 8.56301 0.054375L0.615671 8.0025C0.587549 8.03062 0.570676 8.06437 0.563176 8.10187L0.0101062 11.2556C-0.00813218 11.3561 -0.00161532 11.4594 0.0290924 11.5568C0.0598001 11.6542 0.113773 11.7426 0.186339 11.8144C0.310076 11.9344 0.465686 12 0.632545 12ZM1.89617 8.73L8.69612 1.93125L10.0704 3.30562L3.27041 10.1044L1.6037 10.3987L1.89617 8.73Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutlined);
export default __webpack_public_path__ + "static/media/pencilOutlined.ff6c6544350ba66eb4c1572b3cf40c28.svg";
export { ForwardRef as ReactComponent };